import React from "react";

import { EditorialKpi } from "./type";

export interface Kpi50Props {
  kpi: EditorialKpi[];
}

export default function Kpi50({ kpi }: Kpi50Props) {
  return (
    <div className="kpiClass md:hidden">
      {kpi.map((item, index) => (
        <div className="flex flex-col items-start justify-center" key={index}>
          <p className="font-normal text-center text-white  font-primary text-l mb-xxs md:text-black-0">{item.title}</p>
          <p className="text-center text-white  font-secondary text-m font-secondary-light md:text-black-0">{item.subtitle}</p>
        </div>
      ))}
    </div>
  );
}
